import React from "react";
import cx from "classnames";

import styles from "./password_validator.module.scss";

const PasswordValidator = (password) => {
  let error = null;
  if (password) {
    if (password.length < 6) {
      error = "please enter atleast 6 characters";
    }
  } else {
    error = "please enter password";
  }

  return error;
};

const RenderPasswordError = (error) => {
  return <>{error ? <span className={cx(styles.error)}>{error}</span> : ""}</>;
};

export { PasswordValidator, RenderPasswordError };
